<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAdd">新增合同</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出Excel</el-button>
      </template>
      <template slot-scope="{ row }" slot="status">
        <matrix-tag
          v-if="isContractActive(row)"
          color="#166534"
          text="已启用"
        />
        <matrix-tag
          v-else-if="isContractDraft(row)"
          color="#d97706"
          text="暂存"
        />
        <matrix-tag
          v-else
          color="#64748b"
          text="已作废"
        />
      </template>
      <template slot-scope="{ row }" slot="payWhitelistFlag">
        <matrix-tag
          v-if="isPayWhitelisted(row)"
          color="#2563eb"
          text="已加入"
        />
        <matrix-tag
          v-else
          color="#64748b"
          text="未加入"
        />
      </template>
      <template #menu="{ size, row }">
        <el-button type="text" :size="size" @click="openView(row)">查看</el-button>
        <el-button
          v-if="isContractDraft(row)"
          type="text"
          :size="size"
          @click="openEdit(row)"
        >
          编辑
        </el-button>
        <el-button
          v-if="isContractDraft(row)"
          type="text"
          :size="size"
          @click="onRemove(row)"
        >
          删除
        </el-button>
        <el-button
          v-if="isContractActive(row)"
          type="text"
          :size="size"
          @click="onPlanSplit(row)"
        >
          拆分计划
        </el-button>
        <el-button
          v-if="isContractActive(row) && !isPayWhitelisted(row)"
          type="text"
          :size="size"
          @click="onAddPayWhitelist(row)"
        >
          加入白名单
        </el-button>
        <el-button
          v-if="isContractActive(row) && isPayWhitelisted(row)"
          type="text"
          :size="size"
          @click="onRemovePayWhitelist(row)"
        >
          移出白名单
        </el-button>
        <el-button
          v-if="isContractActive(row)"
          type="text"
          :size="size"
          @click="onVoid(row)"
        >
          作废
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="75vh" top="4vh" width="92%" :title="formTitle" :visible.sync="formVisible">
      <form-component ref="formComponent" :transmit-data="transmitData" @handleClose="handleClose" />
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {
  getList,
  remove,
  voidContract,
  getPlanSplitStatus,
  executePlanSplit,
  exportExcel,
  addPayWhitelist,
  removePayWhitelist,
} from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
import { downloadXls } from "@/util/util";
import matrixTag from "@/components/matrix/matrix-tag";
import FormComponent from "./components/form-component.vue";
import { formatTon } from "./const";

const CONTRACT_STATUS = {
  VOID: 0,
  ACTIVE: 1,
  DRAFT: 2,
};

const CONTRACT_STATUS_OPTIONS = [
  { label: "已启用", value: CONTRACT_STATUS.ACTIVE },
  { label: "已作废", value: CONTRACT_STATUS.VOID },
  { label: "暂存", value: CONTRACT_STATUS.DRAFT },
];

export default {
  name: "TransportContractBasic",
  components: { matrixTag, FormComponent },
  mixins: [crudMixins],
  data() {
    return {
      transmitData: {},
      formVisible: false,
      formTitle: "",
      apiConfig: { getList, remove },
      exportLoading: false,
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 340,
        column: [
          {
            label: "合同编号",
            prop: "contractNo",
            search: true,
            overHidden: true,
            width: 180,
          },
          {
            label: "客户",
            prop: "custNo",
            search: true,
            overHidden: true,
            width: 160,
            type: "select",
            remote: true,
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: {
              label: "deptName",
              value: "id",
            },
            rules: rulesInput(2),
            formatter: (row) => row.custName || row.custNo || "-",
          },
          {
            label: "合同类型",
            prop: "contractType",
            overHidden: true,
            width: 130,
            formatter: (row) => {
              const m = { 1: "仓储服务合同", 2: "翻卸服务合同" };
              const v = row.contractType;
              return m[v] != null ? m[v] : v != null && v !== "" ? String(v) : "-";
            },
          },
          {
            label: "合同名称",
            prop: "contractName",
            search: true,
            overHidden: true,
            minWidth: 160,
          },
          {
            label: "开始时间",
            prop: "contractStartTime",
            overHidden: true,
            width: 110,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "结束时间",
            prop: "contractEndTime",
            overHidden: true,
            width: 110,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "合同总量(吨)",
            prop: "contractWeight",
            overHidden: true,
            width: 120,
            formatter: (row) => formatTon(row.contractWeight),
          },
          {
            label: "累计完成量(吨)",
            prop: "inWeight",
            overHidden: true,
            width: 120,
            formatter: (row) => formatTon(row.inWeight),
          },
          {
            label: "录入时间",
            prop: "createTime",
            overHidden: true,
            width: 160,
          },
          {
            label: "状态",
            prop: "status",
            slot: true,
            search: true,
            type: "select",
            dicData: CONTRACT_STATUS_OPTIONS,
            overHidden: false,
            align: "center",
            width: 100,
            className: "cell-contract-status",
          },
          {
            label: "费用白名单",
            prop: "payWhitelistFlag",
            slot: true,
            overHidden: false,
            align: "center",
            width: 110,
            className: "cell-pay-whitelist",
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
    };
  },
  methods: {
    async handleExport() {
      if ((this.page.total || 0) < 1) {
        this.$message.warning("无数据可导出");
        return;
      }
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `运输合同_${Date.now()}.xlsx`);
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`);
        } else {
          this.$message.success("导出成功");
        }
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    /** 启用：兼容接口返回 status / contractStatus */
    contractStatusValue(row) {
      return row.status != null ? row.status : row.contractStatus;
    },
    isContractActive(row) {
      const s = this.contractStatusValue(row);
      return s === CONTRACT_STATUS.ACTIVE || s === String(CONTRACT_STATUS.ACTIVE);
    },
    isContractDraft(row) {
      const s = this.contractStatusValue(row);
      return s === CONTRACT_STATUS.DRAFT || s === String(CONTRACT_STATUS.DRAFT);
    },
    isPayWhitelisted(row) {
      const flag = row.payWhitelistFlag;
      return flag === 1 || flag === true || flag === "1" || flag === "true";
    },
    openAdd() {
      this.transmitData = { type: "add", id: null };
      this.formTitle = "新增合同";
      this.formVisible = true;
    },
    openView(row) {
      this.transmitData = { type: "view", id: row.id };
      this.formTitle = "合同详情 · " + (row.contractNo || row.contractName || "");
      this.formVisible = true;
    },
    openEdit(row) {
      this.transmitData = { type: "edit", id: row.id };
      this.formTitle = "编辑合同 · " + (row.contractNo || row.contractName || "");
      this.formVisible = true;
    },
    handleClose(type) {
      this.formVisible = false;
      if (type) {
        this.onLoad(this.page, this.query);
      }
    },
    onVoid(row) {
      if (!this.isContractActive(row)) {
        return;
      }
      this.$confirm("作废后合同不可再操作，关联仓储堆位将同步作废，是否继续？", "提示", { type: "warning" })
        .then(() => {
          return voidContract(row.id);
        })
        .then(() => {
          this.$message.success("已作废");
          this.onLoad(this.page, this.query);
        })
        .catch(() => {});
    },
    onRemove(row) {
      if (!this.isContractDraft(row)) {
        return;
      }
      this.$confirm("删除后暂存合同不可恢复，是否继续？", "提示", { type: "warning" })
        .then(() => remove(row.id))
        .then(() => {
          this.$message.success("删除成功");
          this.onLoad(this.page, this.query);
        })
        .catch(() => {});
    },
    onAddPayWhitelist(row) {
      if (!this.isContractActive(row)) {
        return;
      }
      if (!row.contractNo) {
        this.$message.warning("合同编号为空，无法加入白名单");
        return;
      }
      this.$confirm("加入后，该合同下发的汽运入库/出库计划派车单将无需支付服务费，是否继续？", "加入白名单", { type: "warning" })
        .then(() =>
          addPayWhitelist({
            contractId: row.id,
            contractNo: row.contractNo,
            contractName: row.contractName,
          })
        )
        .then(() => {
          this.$message.success("加入白名单成功");
          this.onLoad(this.page, this.query);
        })
        .catch((e) => this.handleActionError(e, "加入白名单失败"));
    },
    onRemovePayWhitelist(row) {
      if (!this.isContractActive(row)) {
        return;
      }
      if (!row.contractNo) {
        this.$message.warning("合同编号为空，无法移出白名单");
        return;
      }
      this.$confirm("移出后，新下发的计划派车单将恢复按车辆支付规则判断，是否继续？", "移出白名单", { type: "warning" })
        .then(() => removePayWhitelist({ contractNo: row.contractNo }))
        .then(() => {
          this.$message.success("移出白名单成功");
          this.onLoad(this.page, this.query);
        })
        .catch((e) => this.handleActionError(e, "移出白名单失败"));
    },
    handleActionError(e, defaultMsg) {
      if (e === "cancel" || e === "close" || (e && e.message === "cancel")) {
        return;
      }
      const errMsg =
        (e && e.response && e.response.data && (e.response.data.msg || e.response.data.error_description)) ||
        (e && e.message) ||
        defaultMsg;
      if (errMsg) {
        this.$message.error(errMsg);
      }
    },
    onPlanSplit(row) {
      if (!this.isContractActive(row)) {
        return;
      }
      getPlanSplitStatus(row.id)
        .then((res) => {
          const data = res && res.data && res.data.data;
          if (data && data.alreadySplit) {
            this.$message.warning("该合同已拆分运输计划，无需重复操作");
            return Promise.reject(new Error("already_split"));
          }
          if (!data || !data.hasEligibleLines) {
            this.$message.warning("当前合同无铁路运输/汽运入库/汽运出库明细可拆分");
            return Promise.reject(new Error("no_eligible"));
          }
          return this.$confirm(
            "将按合同期限，对翻车机卸煤/汽运受煤坑/装车服务费明细生成「年计划」并按月拆分为「月计划」，是否继续？",
            "拆分计划",
            { type: "warning" }
          ).then(() => executePlanSplit(row.id));
        })
        .then((res) => {
          if (!res) {
            return;
          }
          const msg = (res.data && (res.data.msg || res.data.message)) || "拆分成功";
          this.$message.success(msg);
        })
        .catch((e) => {
          if (e === "cancel" || e === "close") {
            return;
          }
          if (e && e.message === "cancel") {
            return;
          }
          if (e && (e.message === "already_split" || e.message === "no_eligible")) {
            return;
          }
          const errMsg =
            (e && e.response && e.response.data && (e.response.data.msg || e.response.data.error_description)) ||
            (e && e.message);
          if (errMsg) {
            this.$message.error(errMsg);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
/* 状态列：标签不被裁切 + 垂直居中（与全站表格行高配合） */
::v-deep td.cell-contract-status .cell,
::v-deep td.cell-pay-whitelist .cell {
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
}
</style>
